import { createAction, props } from '@ngrx/store';
import {
  CreateTaskDto,
  GetTasksDto,
  IBaseListResponse,
  ITask,
  LoadType,
  UpdateTaskDto
} from '@appgen-health-crm/api-interfaces';

/* ----------------------------- Get Tasks ------------------------------ */

export const getTasks = createAction(
  '[Task] Get Tasks',
  props<{ filters: GetTasksDto; loadType?: LoadType }>()
);

export const getTasksSuccess = createAction(
  '[Task] Get Tasks Success',
  props<{ loadType?: LoadType; tasksResp: IBaseListResponse<ITask> }>()
);

export const getTasksFailure = createAction(
  '[Task] Get Tasks Failure',
  props<{ error: Error }>()
);

/* ----------------------------- Get Task By Id ----------------------------- */

export const getTaskById = createAction(
  '[Task] Get Task By Id',
  props<{ id: string }>()
);

export const getTaskByIdSuccess = createAction(
  '[Task] Get Task By Id Success',
  props<{ task: ITask }>()
);

export const getTaskByIdFailure = createAction(
  '[Task] Get Task By Id Failure',
  props<{ error: Error }>()
);

/* ------------------------------ task details ------------------------------ */
export const openTaskDetails = createAction('[Task] Open Task Details');

export const closeTaskDetails = createAction('[Task] Close Task Details');

/* ---------------------------- Create Task --------------------------- */

export const createTask = createAction(
  '[Task] Create Task',
  props<{
    request: CreateTaskDto;
  }>()
);

export const createTaskSuccess = createAction(
  '[Task] Create Task Success',
  props<{ task: ITask }>()
);

export const createTaskFailure = createAction(
  '[Task] Create Task Failure',
  props<{ error: Error }>()
);

export const openCreateTask = createAction('[Task] Open Create Task');

export const closeCreateTask = createAction('[Task] Close Create Task');

/* ---------------------------- Update Task --------------------------- */

export const updateTask = createAction(
  '[Task] Update Task',
  props<{ id: string; task: UpdateTaskDto }>()
);

export const updateTaskSuccess = createAction(
  '[Task] Update Task Success',
  props<{ task: ITask }>()
);

export const updateTaskFailure = createAction(
  '[Task] Update Task Failure',
  props<{ error: Error }>()
);

/* ---------------------------- Delete Task --------------------------- */

export const deleteTask = createAction(
  '[Task] Delete Task',
  props<{ id: string }>()
);

export const deleteTaskSuccess = createAction(
  '[Task] Delete Task Success',
  props<{ id: string }>()
);

export const deleteTaskFailure = createAction(
  '[Task] Delete Task Failure',
  props<{ error: Error }>()
);

/* ------------------------------- set filters ------------------------------ */
export const setFilters = createAction(
  '[Task] Set Filters',
  props<{ filters: GetTasksDto }>()
);
